{
  "apps.scope.label": "当前应用",
  "apps.scope.placeholder": "选择应用",
  "apps.scope.required": "请先在页面右上角选择一个应用，再管理其数据。",
  "apps.status.active": "启用",
  "apps.status.disabled": "停用",
  "apps.actions.enable": "启用",
  "apps.actions.disable": "停用",
  "apps.client_config.actions.open": "客户端配置",
  "apps.client_config.title": "客户端配置",
  "apps.client_config.tabs.share": "分享配置",
  "apps.client_config.tabs.scanner": "扫码配置",
  "apps.client_config.unsaved.title": "放弃未保存的客户端配置？",
  "apps.client_config.unsaved.description": "一个或多个配置页签包含尚未保存的修改。关闭后这些修改将丢失。",
  "apps.client_config.unsaved.discard": "放弃修改",
  "apps.client_config.scanner.runtime_title": "扫码网页安全边界",
  "apps.client_config.scanner.runtime_description": "只有白名单命中的绝对 HTTPS 地址才会在 App 内打开。配置通过公开运行时接口下发；客户端必须成功刷新配置后才会生效。",
  "apps.client_config.scanner.enabled": "允许扫码网页在 App 内打开",
  "apps.client_config.scanner.enabled_help": "关闭时仍保留域名列表，但所有扫码结果只会在 App 内展示。",
  "apps.client_config.scanner.allowed_hosts": "允许的域名",
  "apps.client_config.scanner.allowed_hosts_help": "支持 example.com 和 *.example.com。通配符匹配任意层级子域，但不匹配根域；不允许协议、路径、IP、localhost、非 443 端口或公共后缀通配符。",
  "apps.client_config.scanner.host_required": "启用 App 内网页时至少需要一个允许域名。",
  "apps.client_config.scanner.host_label": "允许域名第 {index} 行",
  "apps.client_config.scanner.host_invalid": "请输入有效的 ASCII/Punycode 精确域名或通配符域名。",
  "apps.client_config.scanner.remove_host": "删除第 {index} 行域名",
  "apps.client_config.scanner.empty_hosts": "尚未添加允许域名。",
  "apps.client_config.scanner.add_host": "添加域名",
  "apps.client_config.scanner.saved": "扫码配置已保存。",
  "apps.client_config.scanner.load_error": "无法加载扫码配置。",
  "apps.client_config.scanner.save_error": "扫码配置保存失败，请检查输入后重试。",
  "apps.client_config.scanner.conflict": "配置已被其他人更新，已刷新为最新版本，请重新确认修改。",
  "apps.locale.zh-CN": "简体中文",
  "apps.locale.en-US": "English",
  "apps.registration.enabled": "开放注册",
  "apps.registration.disabled": "关闭注册",
  "apps.registration.verification.none": "无需验证",
  "apps.registration.verification.email_otp": "邮箱验证码",
  "apps.membership.pending_verification": "待邮箱验证",
  "apps.membership.active": "已启用",
  "apps.membership.disabled": "已停用",
  "apps.values.none": "暂无",
  "apps.feedback.load_error": "无法加载 App 管理数据，请重试。",
  "apps.feedback.save_error": "无法保存更改，请重试。",
  "apps.feedback.validation_error": "请检查并修正表单字段。",
  "apps.feedback.saved": "已保存。",
  "apps.feedback.status_saved": "状态已更新。",
  "apps.feedback.deleted": "已删除。",
  "apps.feedback.conflict": "应用已被其他管理员更新，请刷新后重试。",
  "apps.application.title": "应用管理",
  "apps.application.description": "为当前工作区创建和配置独立的移动应用边界。",
  "apps.application.actions.create": "新建应用",
  "apps.application.actions.add_channel": "添加发布渠道",
  "apps.application.actions.add_screenshot": "添加截图",
  "apps.application.actions.add_store": "添加应用市场",
  "apps.application.actions.batch_delete": "批量删除（{count}）",
  "apps.application.actions.choose_icon": "选择应用图标",
  "apps.application.actions.choose_qrcode": "选择二维码",
  "apps.application.actions.content": "内容管理",
  "apps.application.actions.move_down": "下移",
  "apps.application.actions.move_up": "上移",
  "apps.application.actions.menu": "操作",
  "apps.application.actions.menu_for": "{name} 的操作",
  "apps.application.actions.upgrade_center": "升级中心",
  "apps.application.sections.startup": "启动",
  "apps.startup.actions.add_slide": "添加启动介绍图片",
  "apps.startup.actions.choose_image": "选择图片",
  "apps.startup.actions.publish": "发布新版本",
  "apps.startup.bundle_export_hint": "启动名称、副标题和图标需在发布 App 包前执行随包快照导出；后台保存不会改变已安装包的首次隐私页。",
  "apps.startup.draft_changed": "草稿有变更",
  "apps.startup.draft_synced": "与已发布版本一致",
  "apps.startup.feedback.asset_rejected": "图片尚未扫描通过，或不是 JPEG、PNG、WebP 格式。",
  "apps.startup.feedback.published": "启动介绍新版本已发布。",
  "apps.startup.fields.accessibility_label": "无障碍说明",
  "apps.startup.fields.display_name": "启动名称",
  "apps.startup.fields.enabled": "启动时显示介绍",
  "apps.startup.fields.subtitle": "启动副标题",
  "apps.startup.icon_preview": "应用图标预览",
  "apps.startup.image_preview": "第 {index} 张启动介绍图片预览",
  "apps.startup.image_required": "请选择已扫描通过的图片",
  "apps.startup.publish.description": "将校验所有双语图片并创建不可变的新版本。已经完成旧版本的用户会再次看到新版本。",
  "apps.startup.publish.title": "发布启动介绍新版本？",
  "apps.startup.published_version": "已发布版本 v{version}",
  "apps.startup.slide": "启动介绍位置 {index}",
  "apps.application.channel_card": "渠道 {index}",
  "apps.application.empty": "暂无应用",
  "apps.application.filters.q": "搜索应用",
  "apps.application.filters.landmark": "应用筛选",
  "apps.application.filters.status": "应用状态",
  "apps.application.filters.type": "应用类型",
  "apps.application.columns.appid": "AppID",
  "apps.application.columns.created": "创建时间",
  "apps.application.columns.description": "应用描述",
  "apps.application.columns.name": "应用",
  "apps.application.columns.remark": "备注",
  "apps.application.columns.registration": "注册配置",
  "apps.application.columns.status": "状态",
  "apps.application.columns.type": "应用类型",
  "apps.application.columns.updated": "更新时间",
  "apps.application.columns.actions": "操作",
  "apps.application.delete.title": "删除所选应用？",
  "apps.application.delete.description": "只能删除已停用且非默认的应用。批量删除采用全有或全无事务。",
  "apps.application.editor.create": "新建应用",
  "apps.application.editor.edit": "编辑应用",
  "apps.application.fields.abm_url": "iOS ABM 登录链接",
  "apps.application.fields.app_type": "应用类型",
  "apps.application.fields.appid": "Manifest AppID",
  "apps.application.fields.appid_hint": "设置后不可修改，例如 __UNI__APPKERNIA。",
  "apps.application.fields.channel_code": "渠道",
  "apps.application.fields.channel_name": "渠道应用名称",
  "apps.application.fields.channel_url": "下载或访问地址",
  "apps.application.fields.name": "应用名称",
  "apps.application.fields.default_locale": "默认语言",
  "apps.application.fields.description": "应用描述",
  "apps.application.fields.introduction": "应用简介",
  "apps.application.fields.managers": "管理员",
  "apps.application.fields.members": "成员",
  "apps.application.fields.owner_id": "归属者",
  "apps.application.fields.owner_type": "归属类型",
  "apps.application.fields.registration_enabled": "允许自助注册",
  "apps.application.fields.registration_verification": "注册验证方式",
  "apps.application.fields.registration_verification_mode": "注册验证方式",
  "apps.application.fields.remark": "备注",
  "apps.application.fields.store_enabled": "启用此市场",
  "apps.application.fields.store_name": "市场名称",
  "apps.application.fields.store_priority": "优先级",
  "apps.application.fields.store_scheme": "应用 Scheme",
  "apps.application.fields.uuid_list_hint": "每行一个 UUID。团队资料不会改变 RBAC 授权。",
  "apps.application.owner_types.tenant": "租户",
  "apps.application.owner_types.user": "个人用户",
  "apps.application.sections.assets": "图标",
  "apps.application.sections.basic": "基础信息",
  "apps.application.sections.channels": "渠道",
  "apps.application.sections.owner_team": "所有者与团队",
  "apps.application.sections.stores": "应用市场",
  "apps.application.store_card": "应用市场 {index}",
  "apps.application.types.uni_app": "uni-app",
  "apps.application.types.uni_app_x": "uni-app x",
  "apps.application.validation.appid": "AppID 只能包含字母、数字、点、下划线和短横线。",
  "apps.application.values.appid_pending": "待配置",
  "apps.application.values.none": "未设置",
  "apps.application.channels.android": "Android",
  "apps.application.channels.ios": "iOS",
  "apps.application.channels.harmony": "HarmonyOS Next",
  "apps.application.channels.h5": "H5",
  "apps.application.channels.quickapp": "快应用",
  "apps.application.channels.mp_weixin": "微信小程序",
  "apps.application.channels.mp_alipay": "支付宝小程序",
  "apps.application.channels.mp_baidu": "百度小程序",
  "apps.application.channels.mp_toutiao": "头条小程序",
  "apps.application.channels.mp_qq": "QQ 小程序",
  "apps.application.channels.mp_kuaishou": "快手小程序",
  "apps.application.channels.mp_lark": "飞书小程序",
  "apps.application.channels.mp_jd": "京东小程序",
  "apps.application.channels.mp_dingtalk": "钉钉小程序",
  "apps.users.title": "App 用户管理",
  "apps.users.description": "仅显示明确关联到当前应用的用户；用户身份仍由共享账户基础设施维护。",
  "apps.users.actions.create": "新建用户",
  "apps.users.actions.unlock": "解除锁定",
  "apps.users.actions.reset-password": "重置密码",
  "apps.users.actions.revoke-sessions": "撤销移动端会话",
  "apps.users.empty": "当前应用暂无用户",
  "apps.users.filters.landmark": "App 用户筛选",
  "apps.users.filters.q": "搜索姓名或邮箱",
  "apps.users.filters.status": "成员状态",
  "apps.users.avatar_alt": "用户 {name} 的头像",
  "apps.users.avatar_self_managed": "头像由用户在移动端自行修改。",
  "apps.users.columns.user": "用户",
  "apps.users.columns.source": "来源",
  "apps.users.columns.status": "状态",
  "apps.users.columns.last_sign_in": "最近登录",
  "apps.users.columns.actions": "操作",
  "apps.users.source.self_registration": "自助注册",
  "apps.users.source.admin_created": "后台创建",
  "apps.users.source.legacy": "历史迁移",
  "apps.users.editor.create": "新建 App 用户",
  "apps.users.editor.edit": "编辑 App 用户",
  "apps.users.fields.email": "邮箱",
  "apps.users.fields.display_name": "显示名称",
  "apps.users.fields.password": "初始密码",
  "apps.users.fields.password_hint": "至少 12 个字符；保存后不会再次显示。",
  "apps.users.fields.status": "成员状态",
  "apps.users.fields.locale": "语言偏好",
  "apps.users.password_reset.title": "重置 App 用户密码",
  "apps.users.password_reset.description": "为“{name}”设置新的登录密码。现有移动端会话将由服务端按安全策略处理。",
  "apps.users.password_reset.new_password": "新密码",
  "apps.users.password_reset.confirm_password": "确认新密码",
  "apps.users.feedback.password_reset": "密码已重置。",
  "apps.users.confirm.enable.title": "启用此用户？",
  "apps.users.confirm.enable.description": "将允许“{name}”使用当前应用。",
  "apps.users.confirm.disable.title": "停用此用户？",
  "apps.users.confirm.disable.description": "将阻止“{name}”使用当前应用。",
  "apps.users.confirm.unlock.title": "解除用户锁定？",
  "apps.users.confirm.unlock.description": "将清除“{name}”的登录锁定状态。",
  "apps.users.confirm.reset-password.title": "重置用户密码？",
  "apps.users.confirm.reset-password.description": "将为“{name}”发起安全的密码重置流程。",
  "apps.users.confirm.revoke-sessions.title": "撤销移动端会话？",
  "apps.users.confirm.revoke-sessions.description": "“{name}”在当前应用的移动端会话将立即失效。",
  "apps.pages.title": "单页内容",
  "apps.pages.description": "维护用户协议、隐私政策、关于我们及自定义单页的双语草稿、发布和版本历史。",
  "apps.pages.actions.create": "新建单页",
  "apps.pages.actions.publish": "发布",
  "apps.pages.empty": "暂无单页内容",
  "apps.pages.reserved": "受保护",
  "apps.pages.reserved_hint": "核心单页的标识不可修改，也不能删除。",
  "apps.pages.filters.landmark": "单页内容筛选",
  "apps.pages.filters.q": "搜索单页",
  "apps.pages.columns.title": "标题",
  "apps.pages.columns.type": "类型",
  "apps.pages.columns.status": "状态",
  "apps.pages.columns.updated": "更新时间",
  "apps.pages.columns.actions": "操作",
  "apps.pages.type.privacy-policy": "隐私政策",
  "apps.pages.type.terms-of-service": "用户协议",
  "apps.pages.type.about-us": "关于我们",
  "apps.pages.type.custom": "自定义单页",
  "apps.pages.status.draft": "草稿",
  "apps.pages.status.published": "已发布",
  "apps.pages.editor.create": "新建单页",
  "apps.pages.editor.edit": "编辑单页",
  "apps.pages.fields.slug": "路径标识",
  "apps.pages.fields.type": "内容类型",
  "apps.pages.fields.title": "标题",
  "apps.pages.fields.body": "正文",
  "apps.pages.fields.body_format": "正文格式",
  "apps.pages.fields.blocks": "结构化内容（JSON）",
  "apps.pages.fields.blocks_hint": "仅支持标题、段落、引用、代码、图片、列表和分隔线块。",
  "apps.pages.body_format.markdown": "Markdown",
  "apps.pages.body_format.blocks": "结构化内容",
  "apps.pages.feedback.published": "单页已发布。",
  "apps.pages.feedback.save_before_publish": "请先编辑并保存完整的双语内容，再发布单页。",
  "apps.pages.delete.title": "删除此单页？",
  "apps.pages.delete.description": "将删除“{name}”及其草稿内容；已发布版本仍由服务端审计保留。",
  "apps.pages.type.faq": "常见问题",
  "apps.pages.type.contact-support": "联系支持",
  "apps.feedbacks.title": "问题反馈",
  "apps.feedbacks.description": "查看当前应用的用户反馈、处理进度并回复用户。",
  "apps.feedbacks.filters": "反馈筛选",
  "apps.feedbacks.search": "搜索问题描述",
  "apps.feedbacks.status": "状态",
  "apps.feedbacks.all": "全部状态",
  "apps.feedbacks.dateRange": "提交时间",
  "apps.feedbacks.failed": "操作失败，请重试",
  "apps.feedbacks.empty": "暂无反馈记录",
  "apps.feedbacks.content": "问题描述",
  "apps.feedbacks.platform": "平台",
  "apps.feedbacks.version": "App版本",
  "apps.feedbacks.created": "提交时间",
  "apps.feedbacks.detail": "反馈详情",
  "apps.feedbacks.image": "反馈截图",
  "apps.feedbacks.imageRetry": "重新加载截图",
  "apps.feedbacks.conflict": "该反馈已被更新。输入已保留，请刷新后重试。",
  "apps.feedbacks.refresh": "刷新详情",
  "apps.feedbacks.replyRequired": "请填写1至2000字的回复",
  "apps.feedbacks.user": "用户ID",
  "apps.feedbacks.contact": "联系方式",
  "apps.feedbacks.notProvided": "未填写",
  "apps.feedbacks.markStatus": "标记为{status}",
  "apps.feedbacks.replies": "回复记录",
  "apps.feedbacks.noReply": "暂无回复",
  "apps.feedbacks.reply": "回复内容",
  "apps.feedbacks.replyStatus": "回复后的状态",
  "apps.feedbacks.sendReply": "发送回复",
  "apps.feedbacks.history": "处理记录",
  "apps.feedbacks.status.pending": "待处理",
  "apps.feedbacks.status.processing": "处理中",
  "apps.feedbacks.status.resolved": "已解决",
  "apps.feedbacks.platform.android": "Android",
  "apps.feedbacks.platform.ios": "iOS",
  "apps.feedbacks.platform.harmony": "HarmonyOS",
  "apps.feedbacks.platform.unknown": "未知平台",
  "apps.public_web.title": "发行页配置",
  "apps.public_web.enabled": "公开发行页",
  "apps.public_web.apk_enabled": "允许 Android APK 下载",
  "apps.public_web.promotion_enabled": "显示下载推广",
  "apps.public_web.promotion_section": "H5 下载推广",
  "apps.public_web.promotion_hint": "控制资讯和单页顶部下载入口及文末推广。留空的推广文案会使用 App 名称和系统默认文案。",
  "apps.public_web.promotion_title": "推广标题",
  "apps.public_web.promotion_description": "推广说明",
  "apps.public_web.promotion_button_label": "推广按钮文字",
  "apps.public_web.name": "App 展示名称",
  "apps.public_web.introduction": "App 介绍",
  "apps.public_web.platform": "平台",
  "apps.public_web.web_url": "商店 HTTPS 网页地址",
  "apps.public_web.unset": "待补齐",
  "apps.public_web.view": "查看公开页面",
  "apps.public_web.copy": "复制公开链接",
  "apps.public_web.qr": "发行页二维码",
  "apps.public_web.hint": "平台判断在下载页内完成。未配置平台或 HTTPS 地址的商店不会展示；APK 必须已在升级中心发布。",
  "apps.public_web.origin_missing": "服务器尚未配置公开站点地址，无法启用发行页。",
  "apps.public_web.validation": "请填写两种语言的名称与介绍，并检查商店平台和 HTTPS 地址。",
  "apps.public_web.copied": "链接已复制",
  "apps.public_web.copy_error": "复制失败，请手动复制链接。",
  "apps.public_web.not_published": "仅已发布内容可预览。",
  "apps.public_web.preview": "手机预览",
  "apps.public_web.preview_refresh": "刷新预览",
  "apps.public_web.preview_close": "关闭预览",
  "apps.public_web.preview_hint": "仅模拟手机外观和尺寸，平台识别仍以当前浏览器为准。",
  "apps.public_web.preview_frame": "{name} 的手机预览",
  "apps.public_web.preview_loading": "正在加载公开页面…",
  "apps.public_web.preview_timeout": "无法确认页面已加载，请重试或独立打开。",
  "apps.client_config.tabs.login_providers": "登录配置",
  "apps.client_config.login.title": "登录方式",
  "apps.client_config.login.description": "密码登录始终可用；验证码开关同时控制登录、注册和找回密码。第三方入口由下方平台配置控制。",
  "apps.client_config.login.methods_title": "基础登录方式",
  "apps.client_config.login.password": "用户密码登录",
  "apps.client_config.login.password_help": "默认开启，无法关闭。",
  "apps.client_config.login.otp": "验证码登录",
  "apps.client_config.login.email_otp": "邮件验证码",
  "apps.client_config.login.sms_otp": "短信验证码",
  "apps.client_config.login.channel_required": "启用验证码登录时，请至少开启邮件或短信验证码。",
  "apps.client_config.login.saved": "登录配置已保存。",
  "apps.client_config.login.load_error": "无法加载登录配置。",
  "apps.client_config.login.save_error": "登录配置保存失败，请刷新后重试。",
  "apps.users.actions.delete": "删除用户",
  "apps.users.confirm.delete.title": "确定删除用户？",
  "apps.users.confirm.delete.description": "将删除“{name}”在“{app}”中的账号及关联数据，并使该 App 的登录会话立即失效。此操作无法撤销。",
  "apps.users.confirm.delete.retention": "其他 App、支付与钱包关联按账号注销规则保留；审计及法律同意记录匿名化。独占文件将在后台清理，共享文件保留并去除个人关联。",
  "apps.users.feedback.deleted": "用户已删除，相关独占文件将在后台清理。",
  "apps.users.feedback.delete_error": "删除失败，请重试。",
  "apps.client_config.login.web_qr": "官网会员 App 扫码登录",
  "apps.client_config.login.web_qr_help": "允许本 App 的登录用户扫码确认网站会员登录；与后台员工扫码登录独立。"
}
